export default __webpack_public_path__ + "fonts/GabioDrain Design_Long report- rev.1_ita.pdf";